import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

// nkemailjs240 emailjjs password

const Contact = () => {
  const form = useRef();
  const [done, setDone] = useState(false);

  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_chzwu4w",
        "template_kcc7qbj",
        form.current,
        "Shm_U6SZLDjXmEsxv"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="contact-form" id="Contact">
      {/* LEFT SIDE */}

      <div className="w-left">
        <div className="awesome">
          <span>Get in touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>
      </div>

      {/* RIGHT SIDE  */}

      <div className="c-right">
        <form ref={form} onSubmit={sendEmail}  >
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Name"
                       />
           
          <input
            type="text"
            name="user_email"
            className="user"
            placeholder="Email"
             
          />
 
          <textarea name="message" className="user" placeholder="Message" />
          <input type="submit" value="Send" className="button" />
          <span>{done && "Thanks for connecting me !"}</span>
          <div
            className="blur s-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
